import axios from 'axios';

// Interface für Newsletter-Abonnent
export interface SubscriberRegistration {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  industry: string;
  originalIndustry?: string;
  position: string;
  interests: string[];
  additionalInterests?: string;
  consent: boolean;
  altcha?: string;
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
});

const newsletterService = {
  registerSubscriberAndCreateNewsletter: async (data: SubscriberRegistration) => {
    try {
      const response = await api.post('/api/subscribers', data);
      return response.data;
    } catch (error) {
      console.error('API-Anfrage fehlgeschlagen:', error);
      throw error;
    }
  },

  getSuggestedInterests: async (industry: string, position: string) => {
    try {
      const params: Record<string, string> = { industry, position };

      const response = await api.get('/api/interests/suggestions', { params });
      const interests = response.data.interests || [];
      return interests.sort((a: string, b: string) => a.localeCompare(b));
    } catch (error) {
      console.error('Fehler beim Abrufen der Interessenvorschläge:', error);
      return [
        'Automatisierung',
        'Autonome Systeme',
        'Computer Vision',
        'Data Science',
        'Digitale Transformation',
        'KI-Entwicklungen',
        'KI-Ethik',
        'Machine Learning',
        'Natural Language Processing',
        'Robotik'
      ];
    }
  },

  mapCustomIndustry: async (customIndustry: string, availableIndustries: string[]) => {
    try {
      const response = await api.post('/api/industry/mapping', {
        custom_industry: customIndustry,
        available_industries: availableIndustries
      });
      return response.data.mapped_industry;
    } catch (error) {
      console.error('Fehler beim Mapping der benutzerdefinierten Branche:', error);
      return availableIndustries[0] || 'Technologie & IT';
    }
  }
};

export const registerSubscriberAndCreateNewsletter =
  newsletterService.registerSubscriberAndCreateNewsletter;
export const getInterestSuggestions = newsletterService.getSuggestedInterests;
export const mapCustomIndustry = newsletterService.mapCustomIndustry;

export { newsletterService };
